import type { EntityCrudPermissions, EntityPermissions } from '../api/types';

const ARTICLE_ALIASES = ['news', 'blog'] as const;

function orCrud(a?: EntityCrudPermissions, b?: EntityCrudPermissions): EntityCrudPermissions {
  return {
    create: Boolean(a?.create || b?.create),
    update: Boolean(a?.update || b?.update),
    delete: Boolean(a?.delete || b?.delete),
  };
}

export function normalizeEntityPermissions(
  perms: EntityPermissions | null | undefined,
): EntityPermissions | null {
  if (!perms) return null;

  const article = perms.article;
  if (!article) return perms;

  const next: EntityPermissions = { ...perms };
  for (const key of ARTICLE_ALIASES) {
    next[key] = orCrud(next[key], article);
  }
  delete next.article;
  return next;
}
